export const HOME = '/';

export const AUTH = '/auth';

export const EDIT = `/edit`;
export const CREATE = `/create`;
export const NOT_FOUND = '/not-found';
export const CLIENTS = '/clients';
export const TAO = `${CLIENTS}/tao/:clientId`;
export const JOBS = '/jobs';
export const VIEW_JOB = '/jobs/:jobId';
export const JOBSEEKERS = '/jobseekers';
export const APPLICATIONS = '/applications';
export const VIEW_APPLICATION = '/applications/:applicationId';
export const ACE = '/ace';
export const ATTACHMENTS = '/attachments';
export const RESET_PASSWORD = '/reset';
// For new employers by email link
export const SETUP_PASSWORD = '/setup-password';
export const EMPLOYMENT_CONFIRMATION = '/employmentConfirm';
export const RECRUITMENT_OVERVIEW_REPORT = '/recruitmentOverview';
export const CREATE_JOB = `${JOBS}${CREATE}`;
export const EDIT_JOB = `${JOBS}/:jobId${EDIT}`;
export const CLIENT_CREATE_JOB = `${JOBS}/create`;
// For new employers from joblio.co
export const SET_PASSWORD = '/set-password';
// For restricted clients accounts
export const ACCESS_PENDING = '/access-pending';
